import { render, staticRenderFns } from "./auditFlowRecord.vue?vue&type=template&id=509f871f&scoped=true&"
import script from "./auditFlowRecord.vue?vue&type=script&lang=ts&"
export * from "./auditFlowRecord.vue?vue&type=script&lang=ts&"
import style0 from "./auditFlowRecord.vue?vue&type=style&index=0&id=509f871f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f871f",
  null
  
)

export default component.exports